<template>
  <transition
    name="modal-section"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
    @enter="enter"
    @leave="leave"
    @before-enter="beforeEnter"
    @before-leave="beforeLeave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  methods: {
    beforeEnter: function (el) {
      el.style.height = '0';
      el.style.overflow = 'hidden';
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function (el) {
      el.style.height = 'auto';
      el.style.overflow = 'visible';
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.overflow = 'visible';
    },
    leave: function (el) {
      el.style.height = '0';
      el.style.overflow = 'hidden';
    },
    afterLeave: function (el) {
      el.style.height = 'auto';
      el.style.overflow = 'visible';
    }
  }
}
</script>
